import React from 'react';
import { ILocation } from './types';
import { defaultLocation } from './constants';

export const LocationContext = React.createContext<ILocation>({
  ...defaultLocation,
});
